module.exports = __webpack_public_path__ + "static/media/UBICACION_SEPULTURASMobile.97aae2f4.jpg";